var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H61M19.2083 11.8333V13.4722M27.4028 11.8333V13.4722M35.5972 11.8333V13.4722M43.7917 11.8333V13.4722M19.2083 22.4861V24.125M27.4028 22.4861V24.125M35.5972 22.4861V24.125M43.7917 22.4861V24.125M49.5278 61H13.4722C12.1682 61 10.9177 60.482 9.99561 59.5599C9.07356 58.6379 8.55556 57.3873 8.55556 56.0833V2H54.4444V56.0833C54.4444 57.3873 53.9264 58.6379 53.0044 59.5599C52.0823 60.482 50.8318 61 49.5278 61ZM42.7756 38.9012C40.3729 35.9906 35.9512 31.5 31.5 31.5C27.0488 31.5 22.6271 35.9906 20.2244 38.9012C19.3952 39.9108 20.1359 41.3333 21.4405 41.3333H41.5595C42.8641 41.3333 43.6081 39.9108 42.7756 38.9012ZM24.9444 41.3333V61H38.0556V41.3333H24.9444Z",
    stroke: "#0F4BFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.b78c6b818279e5b2f4a0e10236cfbe08.svg";
export { ForwardRef as ReactComponent };